import { PaymentsDeprecatedOrg, PaymentsDeprecatedProp } from '@wetags/payments-deprecated';

export const useCareCreditLocationStatus = (locationId: string | undefined) => {
  const [isCareCreditEnabled, isCareCreditLoading] = PaymentsDeprecatedProp.useWetag('care-credit-enabled', locationId);
  const { isEnabled: isCareCreditOrgEnabled } = PaymentsDeprecatedOrg.useWetagQuery('care-credit-enabled');

  return {
    isCareCreditOrgEnabled,
    isCareCreditEnabled: isCareCreditEnabled || isCareCreditOrgEnabled || false,
    isCareCreditLoading,
  };
};
